export default __webpack_public_path__ + "static/media/citroen_offer2.2d167ccd.jpg";